import React from 'react';
import { fromPairs, map, get, isEqual } from 'lodash';
import { button as Button } from 'modules/button';
import { Form } from 'modules/form';
import classnames from 'classnames';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { priorAuthorization as PriorAuthorization } from 'ui/views/widgets/priorAuthorization';
 *
 * // render
 * <PriorAuthorization propName='propValue'/>
 */
export const priorAuthorization = ( props ) => {

    // field
    const title = props.title ;

    const { actions = [] } = props;

    const subheaders = props.primaryColumns;

    return (
        <div className='ui-prior-authorization'>
			<div className='ui-prior-authorization__header'>

				{/* title for the modal */}
				<div className='ui-prior-authorization__header__title'>
					{ getLabel( title ) }
				</div>

				{/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>

			</div>

            <div className='ui-prior-authorization__subheader' >
                
                { map( subheaders, ( subheader, index ) => {

                    return (
                        <div key={ index } className='ui-prior-authorization__subheader__item'>
                            <div className='ui-prior-authorization__subheader__item__title'>
                                { getLabel( subheader.title.refId ) }
                            </div>
                            <div className='ui-prior-authorization__subheader__item__value'>
                                { props.data.state[ subheader.name ] }
                            </div>
                        </div>
                    );
                } ) }
            </div>

            <div className='ui-prior-authorization__divider'></div>

            <div className='ui-prior-authorization__body'>

                <Form
                    fields={ fromPairs( map( props.fields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                    values={ props.values } // default values
                    isValid={ false }
                    key={ props.formId }

                    // onChangeCallBack={ props.onChangeCallBack }
                    onSubmit={ ( { values, isValid } ) => {

                        if( isValid ) {
                            props.onFormSubmit( {
                                ...values
                            } );
                        }

                        //props.onSumbitClick( { values, isValid } );

                    } }
                >
                    { ( { fields, values, isValid, errors, onChange, onSumbit } = {} ) => {

                        return (
                            <form
                                onSubmit={ onSumbit }
                                className='ui-prior-authorization__body__form'
                            >
                                { /* fields */ }
                                { map( fields, ( field ) => {

                                    if( get( field, 'config.hide' ) ) {
                                        return null;
                                    }
                                    
                                    const className = classnames(
                                        'ui-prior-authorization__body__form__field',
                                        `ui-prior-authorization__body__form__field--${ field.name }`
                                    );

                                    return (
                                        <field.view
                                            className={ className }
                                            key={ field.name }
                                            name={ field.name }
                                            required={ field.required }
                                            config={ field.config }
                                            placeholder={ field.placeholder }
                                            label={ field.title }
                                            onChange={ onChange }
                                            value={ values[ field.name ] }
                                            error={ errors[ field.name ] }
                                            options={ get( props.options, field.options ) }
                                            subFields={ props.subFields }
                                            optionsList={ props.options }
                                        />
                                    );
                                } ) }

                                {/* button actions */}
                                <div className='ui-prior-authorization__body__actions'>
                                    { map( actions, action => {
                                        return (
                                            <Button
                                                { ...action }
                                                key={ action.name }
                                                id= { action.name }

                                                type= { 'cancel' !== action.name ? 'submit' : 'button' }
                                                disabled={ 'cancel' !== action.name ? !isValid : false }
                                                outline={ 'cancel' === action.name ? true: false }
                                                size='large'
                                                className='ui-prior-authorization__body__actions__action'
                                                onClick = { isEqual( 'cancel', action.name ) ? () => {
                                                    props.closeOverlay();
                                                } : null }
                                            />
                                        );
                                    } ) }
                                </div>

                            </form>
                        );
                    } }
                </Form>
            </div>
           
        </div>
    );
};

// set display name
priorAuthorization.displayName = 'priorAuthorization';

// set default props
priorAuthorization.defaultProps = {};

// prop types
priorAuthorization.propTypes = {};
